import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/* LOT 41 · à l'enregistrement d'une feuille ouverte en pop-up, l'écran courant relit ses données (on reste où l'on était) */
export const signalerMaj = () => window.dispatchEvent(new CustomEvent('donnees-maj'));
export const useMaj = (load) => {
  const ref = useRef(load);
  ref.current = load;
  useEffect(() => { const f = () => ref.current?.(); window.addEventListener('donnees-maj', f); return () => window.removeEventListener('donnees-maj', f); }, []);
};

/* Module d'une route : sert à savoir si une action envoie dans un autre module */
const RACINES = [['finance', 'finance'], ['achats', 'achats'], ['factures', 'achats'], ['catalogue', 'achats'], ['fournisseur', 'achats'], ['stocks', 'stock'], ['stock', 'stock'], ['inventaire', 'stock'], ['haccp', 'hygiene'], ['hygiene', 'hygiene'], ['dlc', 'hygiene'],
  ['equipe', 'equipe'], ['recrutement', 'recrutement'], ['recettes', 'recettes'], ['fiches', 'recettes'], ['menus', 'recettes'], ['reservations', 'reservations'], ['communication', 'communication'], ['communiquer', 'communication'], ['social-media', 'communication'],
  ['reglages', 'reglages'], ['parametres', 'reglages'], ['dashboard', 'accueil'], ['compte', 'compte'], ['mon-compte', 'compte'], ['connecteurs-caisse', 'finance'], ['importer-caisse', 'finance']];
export const moduleDeRoute = (to) => {
  const seg = String(to || '').replace(/^\/+/, '').split(/[/?#]/)[0].toLowerCase();
  return (RACINES.find(([r]) => seg === r || seg.startsWith(`${r}-`)) || [null, null])[1];
};
/* Ouvre la page d'un autre module en pop-up par-dessus l'écran courant (même composant, mêmes données) */
export const ouvrirEnPopup = (to, titre) => { const t = String(to || '').replace(/^\/+/, ''); window.dispatchEvent(new CustomEvent('popup-module', { detail: { to: t, titre, module: moduleDeRoute(t) } })); };
/* Va vers `to` : même module → navigation ; autre module → pop-up par-dessus l'écran courant */
export const allerOuPopup = (navigate, slug, courant, to, titre) => { const m = moduleDeRoute(to); if (m && courant && m !== courant) return ouvrirEnPopup(to, titre); return navigate(`/${slug}/${String(to).replace(/^\/+/, '')}`); };

/* navigate() d'une page de module : une route d'un autre module s'ouvre en pop-up, la page reste là */
export const useNavigate41 = (courant) => {
  const nav = useNavigate();
  return useCallback((to, opts) => {
    if (typeof to !== 'string' || window.self !== window.top) return nav(to, opts);
    const rest = to.startsWith('/') ? to.split('/').slice(2).join('/') : to;
    const m = moduleDeRoute(rest);
    if (m && m !== courant && !opts?.replace) return ouvrirEnPopup(rest);
    return nav(to, opts);
  }, [nav, courant]);
};
